import React from 'react';
import { MapStats } from '../../../models/MapStats';
import styles from './MapCardsView.module.css';

import inferno from '../../../content/maps/de_inferno.jpg';
import mirage from '../../../content/maps/de_mirage.jpg';
import nuke from '../../../content/maps/de_nuke.jpg';
import overpass from '../../../content/maps/de_overpass.jpg';
import ancient from '../../../content/maps/de_ancient.jpg';
import vertigo from '../../../content/maps/de_vertigo.jpg';
import anubis from '../../../content/maps/de_anubis.jpg';
import dust2 from '../../../content/maps/de_dust2.jpg';
import train from '../../../content/maps/de_train.jpg';
import cache from '../../../content/maps/de_cache.jpg';

const mapImages: Record<string, string> = {
    Inferno: inferno, Mirage: mirage, Nuke: nuke, Overpass: overpass,
    Ancient: ancient, Vertigo: vertigo, Anubis: anubis, Dust2: dust2, Train: train,
    Cache: cache,
};

const getWinRateColor = (rate: number): string => {
    if (rate >= 65) return '#4ade80';
    if (rate >= 50) return '#e2e8f0';
    if (rate > 0) return '#fbbf24';
    return '#f87171';
};

interface Props {
    mapStats: MapStats[];
}

const MapCardsView: React.FC<Props> = ({ mapStats }) => {
    if (mapStats.length === 0) {
        return <div className={styles.noData}>No map data available</div>;
    }

    const sorted = [...mapStats].sort((a, b) => b.amountPlayed - a.amountPlayed);

    return (
        <div className={styles.grid}>
            {sorted.map(stat => {
                const winRate = stat.amountPlayed > 0
                    ? Math.round((stat.amountWon / stat.amountPlayed) * 100)
                    : 0;
                const losses = stat.amountPlayed - stat.amountWon;
                const color = getWinRateColor(winRate);

                return (
                    <div key={stat.mapName} className={styles.card}>
                        <img
                            src={mapImages[stat.mapName]}
                            alt={stat.mapName}
                            className={styles.bgImage}
                        />
                        <div className={styles.overlay} />
                        <span className={styles.mapName}>{stat.mapName}</span>

                        <div className={styles.content}>
                            <div className={styles.winRate} style={{ color }}>
                                {stat.amountPlayed > 0 ? `${winRate}%` : '—'}
                            </div>

                            <div className={styles.record}>
                                <span className={styles.wins}>{stat.amountWon}W</span>
                                <span className={styles.separator}>-</span>
                                <span className={styles.losses}>{losses}L</span>
                                <span className={styles.separator}>·</span>
                                <span>{stat.amountPlayed} played</span>
                            </div>

                            <div className={styles.badges}>
                                <span className={`${styles.badge} ${styles.pickBadge}`}>
                                    {stat.amountPicked} picks
                                </span>
                                <span className={`${styles.badge} ${styles.banBadge}`}>
                                    {stat.amountBanned} bans
                                </span>
                                {stat.chosenCTPercentage > 0 && (
                                    <span className={`${styles.badge} ${styles.ctBadge}`}>
                                        CT {stat.chosenCTPercentage}%
                                    </span>
                                )}
                            </div>

                            <div className={styles.winBar}>
                                <div
                                    className={styles.winBarFill}
                                    style={{
                                        width: `${winRate}%`,
                                        backgroundColor: color,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default MapCardsView;
